const { default: axios } = require("axios");

let map;

function initMap() {
  map = new google.maps.Map(document.getElementById("storageMap"), {
    center: { lat: window.mapSettings.lat, lng: window.mapSettings.lng },
    zoom: 8,
  });
}

const eqfeed_callback = function () {
  let bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < window.mapSettings.markers.length; i++) {
    const place = window.mapSettings.markers[i];
    const latLng = new google.maps.LatLng(place.lat, place.lng);
    const infoWindow = new google.maps.InfoWindow();
    let marker = new google.maps.Marker({
      position: latLng,
      map: map,
      title: place.name,
    });
    infoWindow.setContent(
      `<b>${place.name}</b> <br/> ${place.address} <br/> ${place.city}, ${place.state} ${place.postal_code}`
    );
    marker.addListener("click", () => {
      infoWindow.open({
        anchor: marker,
        map,
        shouldFocus: false,
      });
    });
    // google.maps.event.addListener(infoWindow, "domready", function () {
    //   map.setCenter(marker.getPosition());
    // });
    // infoWindow.open(map, marker);
    bounds.extend(marker.getPosition());
  }
  const svgMarker = {
    path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "green",
    fillOpacity: 0.8,
    strokeWeight: 0,
    rotation: 0,
    scale: 1.5,
    anchor: new google.maps.Point(15, 30),
  };
  const latLng = new google.maps.LatLng(window.mapSettings.lat, window.mapSettings.lng);
  // const infoWindow = new google.maps.InfoWindow();
  let marker = new google.maps.Marker({
    position: latLng,
    icon: svgMarker,
    map: map,
  });
  // infoWindow.setContent(`Your location`);
  // marker.addListener("click", () => {
  //   infoWindow.open({
  //     anchor: marker,
  //     map,
  //     shouldFocus: false,
  //   });
  // });
  bounds.extend(marker.getPosition());
  map.fitBounds(bounds);
};

$(".toggle-map").on("click", function (e) {
  if (window.initMap === undefined) {
    window.initMap = initMap();
    window.eqfeed_callback = eqfeed_callback();
  }
});

$("#results-popular-filters > div, #results-featured-types > div").on("click", function (e) {
  let checkbox = $(this).find("input[type='checkbox']");
  if (checkbox.val() == "self-storage") {
    $("form#results-form label:contains('Climate Controlled (CC)')").each((index, el) => {
      $(el).prev().prop("checked", !checkbox.is(":checked"));
    });
    $("form#results-form label:contains('Regular Storage/Non-climate Controlled')").each((index, el) => {
      $(el).prev().prop("checked", !checkbox.is(":checked"));
    });
    checkbox.prop("checked", !checkbox.is(":checked"));
  } else {
    $("form#results-form")
      .find('input[value="' + checkbox.val() + '"]')
      .prop("checked", !checkbox.is(":checked"));
  }
});

$(".result-modal-list-options input[type='checkbox']").on("change", function (e) {
  $("form#results-form #results-popular-filters, form#results-form #results-featured-types")
    .find('input[value="' + $(this).val() + '"]')
    .prop("checked", $(this).is(":checked"));
});

$("#result-mile-radius").on("change", function () {
  $("#result-mile-radius-display").val($(this).val());
});

$("#results-order-by").on("change", function () {
  $(this).closest("form").trigger("submit");
});

$("[ref=phone-number]").on("click", async function () {
  await axios.post("/helper/track/phone/" + $(this).prop("id"));
});
